import { registerRoutes } from 'foremanReact/routes/RoutingService';

import routes from './routes/routes';

registerRoutes('foreman_openscap', routes);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/global_index.js